import LocalPoint from './Point';
import LocalRect from './Rect';

export const Rect = LocalRect;
export const Point = LocalPoint;

export default {
  Point,
  Rect,
};
